import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log('Jwt Interceptor called');
        
        const token = localStorage.getItem('access_token');

        const xhr = request.clone({
            headers: request.headers.set('authorization', `${token}`)
        });

        return next.handle(xhr);
    }
}
